import React, { useCallback } from 'react';
import { useDeleteAsoScenarioMutation, useGetAsoScenarioListQuery } from '../apiAso';
import { useNavigate } from 'react-router';
import { generatePartialPath } from '../../../routes/routerSlice';
import { ROUTES } from '../../../components/menu/getMenuLeftItems';
import { useStableParams } from '../../../routes/useStableParams';
import DeleteAsoModal from '../modals/DeleteAsoModal';

interface DeleteAsoScenarioModalProps {
  asoScenarioId: number;
  asoName?: string;
  onCancel: () => void;
}

const DeleteAsoScenarioModal: React.FC<DeleteAsoScenarioModalProps> = ({
  asoScenarioId,
  asoName,
  onCancel,
}) => {
  const [deleteAso, { isLoading: confirmLoading }] = useDeleteAsoScenarioMutation();
  const modalTitle = `Delete ASO #${asoScenarioId}${asoName ? ` ${asoName}` : ''}?`;
  const { data: asoScenarioList } = useGetAsoScenarioListQuery(undefined);
  const navigate = useNavigate();
  const { projectShortName, asoRequestId } = useStableParams();

  const deleteHandler = useCallback(async () => {
    return deleteAso(asoScenarioId).then(() => {
      const asoScenarioAfterRedirect = asoScenarioList?.find(
        aso => aso.asoRequestId === asoRequestId && aso.id !== asoScenarioId,
      );

      const params: Record<string, string | undefined> = {
        projectShortName: projectShortName ?? undefined,
        asoRequestId: asoRequestId ? String(asoRequestId) : undefined,
        asoScenarioId: asoScenarioAfterRedirect ? String(asoScenarioAfterRedirect.id) : undefined,
      };

      const path = generatePartialPath(ROUTES.asoChildRoute, params, undefined);

      navigate(path);
    });
  }, [deleteAso, asoScenarioId, asoScenarioList, projectShortName, asoRequestId, navigate]);

  return (
    <DeleteAsoModal
      dataTestId="DeleteAsoConfirmationModal"
      modalTitle={modalTitle}
      message="This will remove the ASO Scenario with its configurations."
      onCancel={onCancel}
      confirmLoading={confirmLoading}
      onConfirm={deleteHandler}
    />
  );
};

export default DeleteAsoScenarioModal;
